import { STATE_CODES } from '@constants/common/statesList';

export const SIGNATURE_FILE_MAX_SIZE = 2 * 1024 * 1024;
export const SIGNATURE_FILE_ACCEPT = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/tiff': ['.tiff', '.tif'],
    'image/bmp': ['.bmp'],
};

export const SUFFIX_OPTIONS = [
    {
        value: '',
        text: 'voterRegistration.form.default',
    },
    {
        value: 'JR',
        text: 'voterRegistration.form.suffix.jr',
    },
    {
        value: 'SR',
        text: 'voterRegistration.form.suffix.sr',
    },
    {
        value: 'I',
        text: 'voterRegistration.form.suffix.i',
    },
    {
        value: 'II',
        text: 'voterRegistration.form.suffix.ii',
    },
    {
        value: 'III',
        text: 'voterRegistration.form.suffix.iii',
    },
    {
        value: 'IV',
        text: 'voterRegistration.form.suffix.iv',
    },
    {
        value: 'V',
        text: 'voterRegistration.form.suffix.v',
    },
    {
        value: 'VI',
        text: 'voterRegistration.form.suffix.vi',
    },
    {
        value: 'VII',
        text: 'voterRegistration.form.suffix.vii',
    },
];

export const YES_NO_OPTIONS = [
    {
        value: true,
        text: 'voterRegistration.form.yes',
        optionId: 'yes',
    },
    {
        value: false,
        text: 'voterRegistration.form.no',
        optionId: 'no',
    },
];

export enum RegistrationReason {
    NEW_REGISTRATION = 'NEW_REGISTRATION',
    CHANGE_OF_NAME = 'CHANGE_OF_NAME',
    CHANGE_OF_ADDRESS = 'CHANGE_OF_ADDRESS',
    CHANGE_OF_PARTY = 'CHANGE_OF_PARTY',
    FEDERAL_VOTER = 'FEDERAL_VOTER',
}

export const REGISTRATION_REASON_OPTIONS = [
    {
        value: RegistrationReason.NEW_REGISTRATION,
        text: 'voterRegistration.form.registrationReason.newRegistration',
    },
    {
        value: RegistrationReason.CHANGE_OF_NAME,
        text: 'voterRegistration.form.registrationReason.changeOfName',
    },
    {
        value: RegistrationReason.CHANGE_OF_ADDRESS,
        text: 'voterRegistration.form.registrationReason.changeOfAddress',
    },

    {
        value: RegistrationReason.CHANGE_OF_PARTY,
        text: 'voterRegistration.form.registrationReason.changeOfParty',
    },
    {
        value: RegistrationReason.FEDERAL_VOTER,
        text: 'voterRegistration.form.registrationReason.federalOrStateEmployee',
    },
];

export enum Gender {
    MALE = 'M',
    FEMALE = 'F',
    NON_BINARY = 'N',
    UNKNOWN = 'U',
}

export const GENDER_OPTIONS = [
    {
        value: '',
        text: 'voterRegistration.form.default',
    },
    {
        value: Gender.MALE,
        text: 'voterRegistration.form.gender.male',
    },
    {
        value: Gender.FEMALE,
        text: 'voterRegistration.form.gender.female',
    },
    {
        value: Gender.NON_BINARY,
        text: 'voterRegistration.form.gender.nonBinary',
    },
    {
        value: Gender.UNKNOWN,
        text: 'voterRegistration.form.gender.unknown',
    },
];

export const RACE_OPTIONS = [
    {
        value: '',
        text: 'voterRegistration.form.default',
    },
    {
        value: 'A',
        text: 'voterRegistration.form.race.asian',
    },
    {
        value: 'B',
        text: 'voterRegistration.form.race.black',
    },
    {
        value: 'H',
        text: 'voterRegistration.form.race.hispanic',
    },
    {
        value: 'I',
        text: 'voterRegistration.form.race.nativeAmerican',
    },
    {
        value: 'P',
        text: 'voterRegistration.form.race.pacificIslander',
    },
    {
        value: 'T',
        text: 'voterRegistration.form.race.twoOrMoreRaces',
    },
    {
        value: 'W',
        text: 'voterRegistration.form.race.white',
    },
    {
        value: 'O',
        text: 'voterRegistration.form.race.other',
    },
];

export const UNIT_TYPES_OPTIONS = [
    {
        value: '',
        text: 'voterRegistration.form.default',
    },
    {
        value: 'APT',
        text: 'voterRegistration.form.unitType.apt',
    },
    {
        value: 'BSM',
        text: 'voterRegistration.form.unitType.bsm',
    },
    {
        value: 'BOX',
        text: 'voterRegistration.form.unitType.box',
    },
    {
        value: 'BLD',
        text: 'voterRegistration.form.unitType.bld',
    },
    {
        value: 'DEP',
        text: 'voterRegistration.form.unitType.dep',
    },
    {
        value: 'FL',
        text: 'voterRegistration.form.unitType.fl',
    },
    {
        value: 'FRN',
        text: 'voterRegistration.form.unitType.frn',
    },
    {
        value: 'HNG',
        text: 'voterRegistration.form.unitType.hng',
    },
    {
        value: 'LBB',
        text: 'voterRegistration.form.unitType.lbb',
    },
    {
        value: 'LOT',
        text: 'voterRegistration.form.unitType.lot',
    },
    {
        value: 'LOW',
        text: 'voterRegistration.form.unitType.low',
    },
    {
        value: 'OFC',
        text: 'voterRegistration.form.unitType.ofc',
    },
    {
        value: 'PH',
        text: 'voterRegistration.form.unitType.ph',
    },
    {
        value: 'PIE',
        text: 'voterRegistration.form.unitType.pie',
    },
    {
        value: 'POL',
        text: 'voterRegistration.form.unitType.pol',
    },
    {
        value: 'REA',
        text: 'voterRegistration.form.unitType.rea',
    },
    {
        value: 'RM',
        text: 'voterRegistration.form.unitType.rm',
    },
    {
        value: 'SID',
        text: 'voterRegistration.form.unitType.sid',
    },
    {
        value: 'SLI',
        text: 'voterRegistration.form.unitType.sli',
    },
    {
        value: 'SPC',
        text: 'voterRegistration.form.unitType.spc',
    },
    {
        value: 'STO',
        text: 'voterRegistration.form.unitType.sto',
    },
    {
        value: 'STE',
        text: 'voterRegistration.form.unitType.ste',
    },
    {
        value: 'TRL',
        text: 'voterRegistration.form.unitType.trl',
    },
    {
        value: 'UNI',
        text: 'voterRegistration.form.unitType.uni',
    },
    {
        value: 'UPP',
        text: 'voterRegistration.form.unitType.upp',
    },
    {
        value: 'CBN',
        text: 'voterRegistration.form.unitType.cbn',
    },
    {
        value: 'HUB',
        text: 'voterRegistration.form.unitType.hub',
    },
    {
        value: 'SMC',
        text: 'voterRegistration.form.unitType.smc',
    },
    {
        value: 'TH',
        text: 'voterRegistration.form.unitType.th',
    },
];

export enum PoliticalParty {
    DEMOCRATIC = 'D',
    Republican = 'R',
    GREEN = 'GR',
    LIBERTARIAN = 'LN',
    NOPARTY = 'NF',
    OTHER = 'OTH',
}

export const POLITICAL_PARTY_OPTIONS = [
    {
        value: PoliticalParty.DEMOCRATIC,
        optionId: 'democratic',
        text: 'voterRegistration.form.politicalParty.democratic',
    },
    {
        value: PoliticalParty.Republican,
        optionId: 'republican',
        text: 'voterRegistration.form.politicalParty.republican',
    },
    {
        value: PoliticalParty.GREEN,
        optionId: 'green',
        text: 'voterRegistration.form.politicalParty.green',
    },
    {
        value: PoliticalParty.LIBERTARIAN,
        optionId: 'libertarian',
        text: 'voterRegistration.form.politicalParty.libertarian',
    },
    {
        value: PoliticalParty.NOPARTY,
        optionId: 'noParty',
        text: 'voterRegistration.form.politicalParty.noParty',
    },
    {
        value: PoliticalParty.OTHER,
        optionId: 'otherParty',
        text: 'voterRegistration.form.politicalParty.otherParty',
    },
];

export enum HelpAssistance {
    HearingImpaired = 'HI',
    VisualImpaired = 'VSI',
    WheelchairUser = 'WC',
    PhysicalDisability = 'PD',
    Illiteracy = 'IL',
    LimitedEnglish = 'LN',
}

export const HELP_ASSISTANCE_OPTIONS = [
    { value: '', text: 'voterRegistration.form.default' },
    { value: HelpAssistance.HearingImpaired, text: 'voterRegistration.form.votingAssistance.hi' },
    { value: HelpAssistance.VisualImpaired, text: 'voterRegistration.form.votingAssistance.vsi' },
    { value: HelpAssistance.WheelchairUser, text: 'voterRegistration.form.votingAssistance.wc' },
    { value: HelpAssistance.PhysicalDisability, text: 'voterRegistration.form.votingAssistance.pd' },
    { value: HelpAssistance.Illiteracy, text: 'voterRegistration.form.votingAssistance.il' },
    { value: HelpAssistance.LimitedEnglish, text: 'voterRegistration.form.votingAssistance.ln' },
];

export const US_STATES_OPTIONS = [
    { value: '', text: 'voterRegistration.form.default' },
    ...STATE_CODES.slice(1).map(state => ({
        text: state.stateName,
        value: state.stateCode,
    })),
];

export const SECTION_ORDER = [
    'firstName',
    'lastName',
    'middleName',
    'suffix',
    'isUSCitizen',
    'isAgeAbove18yr',
    'registrationReason',
    'dateOfBirth',
    'gender',
    'race',
    'primaryPhone',
    'primaryEmail',
    'residentialAddress',
    'mailingAddress',
    'identification',
    'politicalParty',
    'votingAssistance',
    'votingInformationChanged',
    'helpWithForm',
    'pollWorker',
    'transferRequest',
    'declaration',
    'file',
];

export const VALIDATIONS = {
    FIRST_NAME: { min: 1, max: 30 },
    LAST_NAME: { min: 1, max: 30 },
    MIDDLE_NAME: { max: 30 },
    ADDRESS_LINE: { max: 40 },
    PHONE: { max: 10 },
    UNIT_NO: { max: 15 },
    CITY: { max: 35 },
    STATE: { max: 2 },
    ZIP: { max: 5 },
    COUNTY: { max: 20 },
    DRIVER_LICENSE: { max: 8 },
    SSN4: { max: 4 },
    OTHER_PARTY: { max: 50 },
    LANGUAGE: { max: 50 },
    REGISTRATION_NUMBER: { max: 12 },
    HELP_WITH_FORM_NAME: { max: 100 },
    HELP_WITH_FORM_ADDRESS: { max: 100 },
    HELP_WITH_FORM_PHONE: { max: 15 },
    VOTING_INFO_CHANGED_ADDRESS: { max: 100 },
    VOTING_INFO_CHANGED_CITY: { max: 30 },
    VOTING_INFO_CHANGED_STATE: { max: 2 },
    VOTING_INFO_CHANGED_ZIP: { max: 5 },
    VOTING_INFO_CHANGED_COUNTY: { max: 20 },
    VOTING_INFO_CHANGED_YEAR: { min: 1900 },
};

export enum ADDRESS_TYPE {
    RESIDENTIAL = 'residentialAddress',
    MAILING = 'mailingAddress',
}
